import React from 'react';
import BackButton from './BackButton';

function SavedInventionAssessmentsPage({ setPage, savedInventionAssessments, deleteSavedInventionAssessment }) {
  return (
    <div style={{ minHeight: '100vh', background: 'white' }}>
      <header style={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <BackButton onClick={() => setPage('search')} />
          <img src="/logo.svg" alt="PatTrak Logo" style={{ height: '32px', cursor: 'pointer' }} onClick={() => setPage('search')} />
        </div>
      </header>

      <main style={{ maxWidth: '900px', margin: '40px auto', padding: '0 16px' }}>
        <h1 style={{ fontSize: '32px', fontWeight: 'bold', color: '#1d2934', marginBottom: '8px' }}>
          Saved Invention Assessments
        </h1>
        <p style={{ color: '#64748b', marginBottom: '24px' }}>
          Your saved full invention assessments with all 5 analysis tools
        </p>

        {savedInventionAssessments.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '48px', background: '#f8fafc', borderRadius: '12px' }}>
            <p style={{ fontSize: '16px', color: '#64748b', marginBottom: '16px' }}>No saved assessments yet.</p>
            <button
              onClick={() => setPage('invention-assessment')}
              style={{
                padding: '12px 24px',
                background: '#0369a1',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: '600'
              }}
            >
              Start New Assessment
            </button>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {savedInventionAssessments.map((assessment) => (
              <div key={assessment.id} style={{ border: '1px solid #e2e8f0', borderRadius: '12px', padding: '20px', background: 'white' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#1e293b', marginBottom: '4px' }}>
                      {assessment.title}
                    </h3>
                    <p style={{ fontSize: '13px', color: '#64748b' }}>
                      Saved: {new Date(assessment.created_at).toLocaleDateString()}
                    </p>
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    {assessment.report_html && (
                      <button
                        onClick={() => {
                          const w = window.open('', '_blank');
                          w.document.write(assessment.report_html);
                          w.document.close();
                        }}
                        style={{
                          padding: '8px 16px',
                          background: '#0369a1',
                          color: 'white',
                          border: 'none',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '13px'
                        }}
                      >
                        View Report
                      </button>
                    )}
                    <button
                      onClick={() => {
                        if (window.confirm('Delete this assessment?')) {
                          deleteSavedInventionAssessment(assessment.id);
                        }
                      }}
                      style={{
                        padding: '8px 16px',
                        background: 'white',
                        color: '#dc2626',
                        border: '1px solid #dc2626',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '13px'
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
                <div style={{ marginTop: '12px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {assessment.assessments_data?.patentability && (
                    <span style={{ padding: '4px 10px', background: '#dcfce7', color: '#166534', borderRadius: '12px', fontSize: '12px' }}>
                      Patentability: {assessment.assessments_data.patentability.signal || 'Done'}
                    </span>
                  )}
                  {assessment.assessments_data?.fto && (
                    <span style={{ padding: '4px 10px', background: '#fef3c7', color: '#92400e', borderRadius: '12px', fontSize: '12px' }}>
                      FTO: {assessment.assessments_data.fto.overall_risk || 'Done'}
                    </span>
                  )}
                  {assessment.assessments_data?.landscape && (
                    <span style={{ padding: '4px 10px', background: '#e0f2fe', color: '#0369a1', borderRadius: '12px', fontSize: '12px' }}>
                      Landscape: {assessment.assessments_data.landscape.maturity_stage || 'Done'}
                    </span>
                  )}
                  {assessment.assessments_data?.priorArt && (
                    <span style={{ padding: '4px 10px', background: '#f3e8ff', color: '#7c3aed', borderRadius: '12px', fontSize: '12px' }}>
                      Prior Art: Done
                    </span>
                  )}
                  {assessment.assessments_data?.competitive && (
                    <span style={{ padding: '4px 10px', background: '#fce7f3', color: '#be185d', borderRadius: '12px', fontSize: '12px' }}>
                      Competitive: Done
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

export default SavedInventionAssessmentsPage;
